//@flow
import {makeStyles} from '@material-ui/core/styles';
import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {Hidden} from '@material-ui/core';
import {VisibilityOutlined} from '@material-ui/icons';

import VendorLogo from '../VendorLogo/VendorLogo';
import HeaderSearchBar from '../HeaderSearchBar';
import ActionAppBarIconButton from './ActionAppBarIconButton';
import ActionAppBarNotificationsButton from './ActionAppBarNotificationsButton';
import ActionAppBarDivider from './ActionAppBarDivider';
import ProfileButton from '../ProfileButton/ProfileButton';
import {useStoreDomain, useStoreInfo} from '../../modules/store/utils';
import {useUser} from '../../modules/auth/utils';

import type {Node} from 'react';

type Props = {
  className?: string,
  onSearch?: (searchTerm: string) => void,
  searchPlaceholder?: string,
  children?: Node,
};

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'sticky',
    top: 0,
    background: 'rgba(255, 255, 255, 0.85)',
    backdropFilter: 'blur(1rem)',
    height: 72,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0,
    },
  },
  toolbar: {
    padding: `0px .5rem`,
    borderBottom: '1px solid #E8E8E9',
    height: 72,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      padding: '0 1rem',
    },
  },
  leftContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flex: '0 0 auto',
  },
  centerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1 1 auto',
    maxWidth: 500,
    margin: `0 ${theme.spacing(2)}`,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 300,
      margin: `0 ${theme.spacing(1)}`,
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 200,
      margin: `0 ${theme.spacing(0.5)}`,
    },
  },
  rightContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '.75rem',
    flex: '0 0 auto',
  },
  logo: {
    [theme.breakpoints.down('xs')]: {
      '& img': {
        height: 36,
      },
    },
  },
}));

export default function HeaderBar(props: Props) {
  const {
    className,
    onSearch,
    searchPlaceholder = 'Buscar...',
    children,
  } = props;

  const classes = useStyles();
  const store = useStoreInfo();
  const user = useUser();
  const {domain} = useStoreDomain();

  if (!store || !user) return null;

  const storeUrl = `${window.location.protocol}//${domain.domainName}`;

  return (
    <AppBar
      position="relative"
      className={`${classes.appBar} ${className ? className : ''}`}
      elevation={0}
    >
      <Toolbar className={classes.toolbar}>
        <div className={classes.leftContent}>
          <Hidden mdUp>
            <div className={classes.logo}>
              <VendorLogo />
            </div>
          </Hidden>
          <Hidden xsUp>
            <div className={classes.centerContent}>
              <HeaderSearchBar
                placeholder={searchPlaceholder}
                onSearch={onSearch}
              />
            </div>
          </Hidden>
        </div>
        <div className={classes.rightContent}>
          <ActionAppBarIconButton
            icon={<VisibilityOutlined />}
            title="Ver Tienda"
            href={storeUrl}
            target="_blank"
          />
          <ActionAppBarNotificationsButton />
          <Hidden smDown>
            <ActionAppBarDivider />
          </Hidden>
          <ProfileButton />
        </div>
      </Toolbar>
      {children}
    </AppBar>
  );
}
